import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { IAddressInfo } from "../interface/ITrader";
import { GetAddressbyTraderIdParamModel } from "../model/address";
import AddressService from "../service/AddressService";

import { RootState } from "../store/store";

import { logoutUser } from "./common";

export const resetAddress = createAction("address/reset");

const _service = new AddressService();

export const getAddressAsync = createAsyncThunk(
  "address/address",
  async (params: GetAddressbyTraderIdParamModel) => {
    const response = await _service.getAddresService(params);
    return response;
  }
);

export const getLiveAddressAsync = createAsyncThunk(
  "trader/getALiveAddress",
  async (params: GetAddressbyTraderIdParamModel) => {
    const response = await _service.getLiveAddressService(params);
    return response;
  }
);



type SliceState = {
  value: IAddressInfo[] | null;
  status: string;
  apiCallCount: number;
  traderLive:boolean
};
const initialState = {
  value: null,
  status: COMMON_STATUS.INITIAL,
  apiCallCount: 0,
} as SliceState;

export const addressRuleSlice = createSlice({
  name: "address",
  initialState,
  reducers: {
    updateAddresses: (state: SliceState, action) => {
      if (state && state.value) {
        state.value.map((m: IAddressInfo) => {
          const found = action.payload.find((aId: number) => m.id === aId);
          m.live = found > 0;
        });

      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAddressAsync.pending, (state: SliceState) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getAddressAsync.fulfilled, (state: SliceState, action) => {
        state.value = action.payload.addresses;
        state.traderLive =  action.payload.traderLive;
        state.status = COMMON_STATUS.LOADED;
        state.apiCallCount = 0;
      })
      .addCase(getAddressAsync.rejected, (state: SliceState) => {
        state.status = COMMON_STATUS.FAILED;
        state.apiCallCount += 1;
      })
      .addCase(getLiveAddressAsync.pending, (state: SliceState) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getLiveAddressAsync.fulfilled, (state: SliceState, action) => {
        if (state && state.value) {
          state.value.map((m: IAddressInfo) => {
            const found = action.payload.find((aId: number) => m.id === aId);
            m.live = found > 0;
          });
  
        }
        state.status = COMMON_STATUS.LOADED;
        state.apiCallCount = 0;
      })
      .addCase(getLiveAddressAsync.rejected, (state: SliceState) => {
        state.status = COMMON_STATUS.FAILED;
        state.apiCallCount += 1;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetAddress, () => {
        return initialState;
      });
  },
});

export const { updateAddresses } = addressRuleSlice.actions;
export const getAddress = (state: RootState) => state.address;
export const getLiveAddresses = (state: RootState) => state.address?.value?.filter((add) => {
  return add.live;
});
export const getAddressStatus = (state: RootState) => state.address?.status;
export default addressRuleSlice.reducer;
